import React from 'react';
import './blog-post.css';
import ghc3 from './pictures/ghc3.jpg';
import ghc1 from './pictures/ghc1.jpg';
import ghc2 from './pictures/ghc2.jpg';
import notes1 from './pictures/notes1.jpg';
import notes2 from './pictures/notes2.jpg';

//import reportWebVitals from './reportWebVitals';

const Gracehopper = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Grace Hopper Reflection Dinner Recap</h2>
                    <p class="site-post-meta">November 14th, 2023</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    Last week, we hosted our Grace Hopper Reflection Dinner with those who attended the conference! 
                    Everyone shared their thoughts in reflecting their experiences. We did a poster activity during the 
                    discussion in increasing the representation of women within the Allen School 
                    and tech careers. Thank you so much for the amazing responses and attending the dinner!
                    <br></br>
                     
                    </p>
                    <img src={ghc3} alt="Group picture"/>
                    <img src={ghc1} alt="Attendees reflecting the conference"/>
                    <img src={ghc2} alt="Attendees reflecting the conference"/>
                    <img src={notes1} alt="Post-it notes for attendees to write thier reflection"/>
                    <img src={notes2} alt="Post-it notes for attendees to write thier reflection"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Gracehopper;

